import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import {
    faDiceD20,
    faUsers,
    faSearchDollar,
    faTools,
    faMoneyBillAlt,
    faUniversity,
    faKey,
    faInfoCircle,
    faCog,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ClickAwayListener } from "@material-ui/core";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link, NavLink, Switch } from "react-router-dom";
import AssistenciaTecnicaTab from "../../Components/Menu/AssistenciaTecnicaTab";
import AtendimentoTab from "../../Components/Menu/AtendimentoTab";
import CobrancaTab from "../../Components/Menu/CobrancaTab";
import GeralTab from "../../Components/Menu/GeralTab";
import HelpDeskTab from "../../Components/Menu/HelpDeskTab";
import Notificacoes from "../../Components/Menu/Notificacoes";
import QuickUser from "../../Components/Menu/QuickUsers";
import RepasseTab from "../../Components/Menu/RepasseTab";
import VendasTab from "../../Components/Menu/VendasTab";
import { KTUserProfile } from "../../Tools/EventTemplate";
import { formatMoneyReais } from "../../Tools/FormatTools";
import { ACESSOS } from "../Acessos";
import PrivatedRoute from "../PrivatedRoute";
import LogoWhiteCapys from "../../Assets/img/LogoWhiteCapys.png";
import { useAtedimento } from "../../Context/Atendimento";
import { useUserInfor } from "../../Context/User";
import { Dispatch, SetStateAction, useState } from "react";
import { useModuloInfo } from "../../Context/ModuloInfo";
import MinhaAgenda from "../../Components/Menu/MinhaAgenda";
import { mostrarNavDeTela } from "../../Validations/UsuarioTela";
import VistoriaEntregaChaveTab from "../../Components/Menu/VistoriaEntregaChaveTab";
import NovasNotificacoes from "../../Components/Menu/Notificacoes/NovasNotificacoes";
import NotificacoesAtendimentos from "../../Components/Menu/Notificacoes/NotificacoesAtendimentos";
import AutomacaoTab from "../../Components/Menu/AutomacaoTab";

interface IHeaderProps {
    setProfileMobile: Dispatch<SetStateAction<string>>;
}

export default function Header(props: IHeaderProps) {
    const { modoAtendimento, fila, indicadoresFila, HELP_DESK } =
        useAtedimento();
    const { UserInfor } = useUserInfor();
    const [showMobile, setshowMobile] = useState("");
    const { color } = useModuloInfo();

    const mostrarDropdownAgendamento = UserInfor.MODULOS?.some((m) =>
        mostrarNavDeTela(ACESSOS.GERAL.TELAS.AGENDA.ID_TELA, UserInfor.TELAS)
    );

    return (
        <div id="kt_header" className="header flex-column header-fixed">
            {!modoAtendimento && (
                <div
                    id="kt_header_mobile"
                    className="header-mobile bg-capys header-mobile-fixed"
                >
                    <Link to="/Geral">
                        <img
                            alt="Logo"
                            src={LogoWhiteCapys}
                            className="max-h-30px"
                            title="CRMv2 CAPYS"
                        />
                    </Link>
                    <div className="d-flex align-items-center">
                        <button
                            className="btn p-0 burger-icon burger-icon-left ml-4"
                            id="kt_header_mobile_toggle"
                            onClick={() => {
                                setshowMobile("header-navs-on");
                            }}
                        >
                            <span></span>
                        </button>
                        <button
                            className="btn p-0 ml-2"
                            id="kt_header_mobile_topbar_toggle"
                            onClick={() => {
                                props.setProfileMobile("topbar-mobile-on");
                            }}
                        >
                            <span className="svg-icon svg-icon-xl">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24px"
                                    height="24px"
                                    viewBox="0 0 24 24"
                                    version="1.1"
                                >
                                    <g
                                        stroke="none"
                                        strokeWidth="1"
                                        fill="none"
                                        fillRule="evenodd"
                                    >
                                        <polygon points="0 0 24 0 24 24 0 24" />
                                        <path
                                            d="M12,11 C9.790861,11 8,9.209139 8,7 C8,4.790861 9.790861,3 12,3 C14.209139,3 16,4.790861 16,7 C16,9.209139 14.209139,11 12,11 Z"
                                            fill="#000000"
                                            fillRule="nonzero"
                                            opacity="0.3"
                                        />
                                        <path
                                            d="M3.00065168,20.1992055 C3.38825852,15.4265159 7.26191235,13 11.9833413,13 C16.7712164,13 20.7048837,15.2931929 20.9979143,20.2 C21.0095879,20.3954741 20.9979143,21 20.2466999,21 C16.541124,21 11.0347247,21 3.72750223,21 C3.47671215,21 2.97953825,20.45918 3.00065168,20.1992055 Z"
                                            fill="#000000"
                                            fillRule="nonzero"
                                        />
                                    </g>
                                </svg>
                            </span>
                        </button>
                    </div>
                </div>
            )}
            <div
                className="header-top"
                style={{ backgroundColor: `var(${color})` }}
            >
                <div className="container-fluid">
                    <div className="d-none d-lg-flex align-items-center mr-3">
                        <Link
                            to={ACESSOS.GERAL.DS_BASE_URL}
                            className="mr-20"
                            target={modoAtendimento ? "_blank" : undefined}
                        >
                            <img
                                alt="Logo"
                                src={LogoWhiteCapys}
                                className="max-h-35px"
                                title="CRMv2 CAPYS"
                            />
                        </Link>

                        <ul
                            className="header-tabs flex-nowrap nav align-self-end font-size-lg"
                            role="tablist"
                        >
                            <li className="nav-item d-flex">
                                <NavLink
                                    to={ACESSOS.GERAL.DS_BASE_URL}
                                    activeClassName="active"
                                    className={`nav-link py-4 px-6 ${
                                        modoAtendimento ? "disabled" : ""
                                    }`}
                                    data-toggle="tab"
                                    data-target="#GeralTab"
                                    role="tab"
                                    title="Geral"
                                >
                                    <label>Geral</label>
                                    <FontAwesomeIcon
                                        icon={faDiceD20}
                                        size="lg"
                                    />
                                </NavLink>
                            </li>
                            <li className="nav-item d-flex mr-3">
                                <NavLink
                                    to={ACESSOS.ATENDIMENTO.DS_BASE_URL}
                                    activeClassName="active"
                                    className={`nav-link py-4 px-6 ${
                                        modoAtendimento ? "disabled" : ""
                                    }`}
                                    data-toggle="tab"
                                    data-target="#AtendimentoTab"
                                    role="tab"
                                    title="Atendimento ao Cliente"
                                >
                                    <label>Atendimento ao Cliente</label>
                                    <FontAwesomeIcon icon={faUsers} size="lg" />
                                </NavLink>
                            </li>
                            <li className="nav-item d-flex mr-3">
                                <NavLink
                                    to={ACESSOS.COBRANCA.DS_BASE_URL}
                                    activeClassName="active"
                                    className={`nav-link py-4 px-6 ${
                                        modoAtendimento ? "disabled" : ""
                                    }`}
                                    data-toggle="tab"
                                    data-target="#CobrancaTab"
                                    role="tab"
                                    title="Cobrança"
                                >
                                    <label>Cobrança</label>
                                    <FontAwesomeIcon
                                        icon={faSearchDollar}
                                        size="lg"
                                    />
                                </NavLink>
                            </li>
                            <li className="nav-item d-flex mr-3">
                                <NavLink
                                    to="/AssistenciaTecnica"
                                    activeClassName="active"
                                    className={`nav-link py-4 px-6 ${
                                        modoAtendimento ? "disabled" : ""
                                    }`}
                                    data-toggle="tab"
                                    data-target="#AssistenciaTecnicaTab"
                                    role="tab"
                                    title="Assistêcia Técnica"
                                >
                                    <label>Assistencia Técnica</label>
                                    <FontAwesomeIcon icon={faTools} size="lg" />
                                </NavLink>
                            </li>
                            <li className="nav-item d-flex mr-3">
                                <NavLink
                                    to="/Vendas"
                                    activeClassName="active"
                                    className={`nav-link py-4 px-6 ${
                                        modoAtendimento ? "disabled" : ""
                                    }`}
                                    data-toggle="tab"
                                    data-target="#AssistenciaTecnicaTab"
                                    role="tab"
                                    title="Vendas"
                                >
                                    <label>Vendas</label>
                                    <FontAwesomeIcon
                                        icon={faMoneyBillAlt}
                                        size="lg"
                                    />
                                </NavLink>
                            </li>
                            <li className="nav-item d-flex mr-3">
                                <NavLink
                                    to="/Repasse"
                                    activeClassName="active"
                                    className={`nav-link py-4 px-6 ${
                                        modoAtendimento ? "disabled" : ""
                                    }`}
                                    data-toggle="tab"
                                    data-target="#AssistenciaTecnicaTab"
                                    role="tab"
                                    title="Repasse"
                                >
                                    <label>Repasse</label>
                                    <FontAwesomeIcon
                                        icon={faUniversity}
                                        size="lg"
                                    />
                                </NavLink>
                            </li>
                            <li className="nav-item d-flex mr-3">
                                <NavLink
                                    to="/EntregaChaves"
                                    activeClassName="active"
                                    className={`nav-link py-4 px-6 ${
                                        modoAtendimento ? "disabled" : ""
                                    }`}
                                    data-toggle="tab"
                                    data-target="#EntregaChaves"
                                    role="tab"
                                    title="Entrega de Chaves"
                                >
                                    <label>Entrega de Chaves</label>
                                    <FontAwesomeIcon icon={faKey} size="lg" />
                                </NavLink>
                            </li>
                            {/* <li className="nav-item d-flex mr-3">
                                    <NavLink to="/PortalAdmin" 
                                            
                                          activeClassName="active"
                                          className={`nav-link py-4 px-6 ${modoAtendimento?'disabled':''}`}
                                          data-toggle="tab" 
                                          data-target="#PortalAdmin" 
                                          role="tab"
                                          title="Pós Ocupacional"
                                    >
                                            <label>Pós Ocupacional</label>
                                        <FontAwesomeIcon icon={faHouseUser} size="lg"/>
                                    </NavLink>
                                  </li> */}
                            <li className="nav-item d-flex mr-3">
                                <NavLink
                                    to={ACESSOS.HELPDESK.DS_BASE_URL}
                                    activeClassName="active"
                                    className={`nav-link py-4 px-6 ${
                                        modoAtendimento ? "disabled" : ""
                                    }`}
                                    data-toggle="tab"
                                    data-target="#HelpDesk"
                                    role="tab"
                                    title="Atendimento Whatsapp"
                                >
                                    <label>Atendimento Whatsapp</label>
                                    <FontAwesomeIcon
                                        icon={faWhatsapp}
                                        size="lg"
                                    />
                                </NavLink>
                            </li>
                            <li className="nav-item d-flex mr-3">
                                <NavLink
                                    to={ACESSOS.AUTOMACAO.DS_BASE_URL}
                                    activeClassName="active"
                                    className={`nav-link py-4 px-6 ${
                                        modoAtendimento ? "disabled" : ""
                                    }`}
                                    data-toggle="tab"
                                    data-target="#Automacao"
                                    role="tab"
                                    title="Automação"
                                >
                                    <label>Automação</label>
                                    <FontAwesomeIcon icon={faCog} size="lg" />
                                </NavLink>
                            </li>
                        </ul>
                    </div>

                    <ClickAwayListener
                        mouseEvent="onMouseDown"
                        touchEvent="onTouchEnd"
                        onClickAway={() => {
                            props.setProfileMobile("");
                        }}
                    >
                        <div
                            className="topbar"
                            style={{ backgroundColor: `var(${color})` }}
                        >
                            {mostrarDropdownAgendamento && (
                                <div className="topbar-item" title="Agenda">
                                    <MinhaAgenda />
                                </div>
                            )}
                            <div className="topbar-item" title="Atendimentos">
                                <NotificacoesAtendimentos />
                            </div>
                            <div className="topbar-item" title="Notificações">
                                <NovasNotificacoes />
                            </div>
                            <div className="topbar-item" title="Transferências">
                                <Notificacoes />
                            </div>
                            <div className="topbar-item">
                                <div
                                    className="btn btn-icon btn-hover-transparent-white w-sm-auto d-flex align-items-center btn-lg px-2"
                                    id="kt_quick_user_toggle"
                                    onClick={() => {
                                        KTUserProfile();
                                    }}
                                >
                                    <div className="d-flex flex-column text-right pr-sm-3">
                                        <span className="text-white opacity-50 font-weight-bold font-size-sm d-none d-sm-inline">
                                            {UserInfor.DS_LOGIN}
                                        </span>
                                        <span className="text-white font-weight-bolder font-size-sm d-none d-sm-inline">
                                            {UserInfor.DS_NOME}
                                        </span>
                                    </div>
                                    <span className="symbol symbol-35">
                                        <span className="symbol-label font-size-h5 font-weight-bold text-white bg-white-o-30 text-uppercase">
                                            {UserInfor.DS_NOME?.substring(0, 1)}
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </ClickAwayListener>
                    <QuickUser />
                </div>
            </div>

            <div className="header-bottom">
                <div className="container-fluid">
                    <ClickAwayListener
                        mouseEvent="onMouseDown"
                        touchEvent="onTouchEnd"
                        onClickAway={() => {
                            setshowMobile("");
                        }}
                    >
                        <div
                            className={`header-navs header-navs-left mobile-header-scrollable ${showMobile}`}
                            id="kt_header_navs"
                        >
                            <ul
                                className="header-tabs p-5 p-lg-0 d-flex d-lg-none nav nav-bold nav-tabs"
                                role="tablist"
                            >
                                <li className="nav-item mr-2">
                                    <NavLink
                                        to={ACESSOS.GERAL.DS_BASE_URL}
                                        exact
                                        activeClassName="active"
                                        className="nav-link py-4 px-6"
                                        data-toggle="tab"
                                        data-target="#GeralTab"
                                        role="tab"
                                    >
                                        Geral
                                    </NavLink>
                                </li>
                                <li className="nav-item mr-2">
                                    <NavLink
                                        to={ACESSOS.ATENDIMENTO.DS_BASE_URL}
                                        activeClassName="active"
                                        className="nav-link btn btn-clean"
                                        data-toggle="tab"
                                        data-target="#AtendimentoTab"
                                        role="tab"
                                    >
                                        Atendimento
                                    </NavLink>
                                </li>
                                <li className="nav-item mr-2">
                                    <NavLink
                                        to={ACESSOS.COBRANCA.DS_BASE_URL}
                                        activeClassName="active"
                                        className="nav-link btn btn-clean"
                                        data-toggle="tab"
                                        data-target="#CobrancaTab"
                                        role="tab"
                                    >
                                        Cobrança
                                    </NavLink>
                                </li>
                                <li className="nav-item mr-2">
                                    <NavLink
                                        to="/AssistenciaTecnica"
                                        activeClassName="active"
                                        className="nav-link btn btn-clean"
                                        data-toggle="tab"
                                        data-target="#AssistenciaTecnicaTab"
                                        role="tab"
                                    >
                                        Assistencia Técnica
                                    </NavLink>
                                </li>
                                <li className="nav-item mr-2">
                                    <NavLink
                                        to="/Vendas"
                                        activeClassName="active"
                                        className="nav-link btn btn-clean"
                                        data-toggle="tab"
                                        data-target="#Vendas"
                                        role="tab"
                                    >
                                        Vendas
                                    </NavLink>
                                </li>
                                <li className="nav-item mr-2">
                                    <NavLink
                                        to="/Repasse"
                                        activeClassName="active"
                                        className="nav-link btn btn-clean"
                                        data-toggle="tab"
                                        data-target="#Repasse"
                                        role="tab"
                                    >
                                        Repasse
                                    </NavLink>
                                </li>
                                <li className="nav-item mr-2">
                                    <NavLink
                                        to="/EntregaChaves"
                                        activeClassName="active"
                                        className="nav-link btn btn-clean"
                                        data-toggle="tab"
                                        data-target="#EntregaChaves"
                                        role="tab"
                                    >
                                        Entrega de Chaves
                                    </NavLink>
                                </li>
                                <li className="nav-item mr-2">
                                    <NavLink
                                        to="/PortalAdmin"
                                        activeClassName="active"
                                        className="nav-link btn btn-clean"
                                        data-toggle="tab"
                                        data-target="#PortalAdmin"
                                        role="tab"
                                    >
                                        Portal Admin
                                    </NavLink>
                                </li>
                                <li className="nav-item mr-2">
                                    <NavLink
                                        to={ACESSOS.HELPDESK.DS_BASE_URL}
                                        activeClassName="active"
                                        className="nav-link btn btn-clean"
                                        data-toggle="tab"
                                        data-target="#HelpDesk"
                                        role="tab"
                                    >
                                        Atendimento Whatsapp
                                    </NavLink>
                                </li>
                                <li className="nav-item mr-2">
                                    <NavLink
                                        to={ACESSOS.AUTOMACAO.DS_BASE_URL}
                                        activeClassName="active"
                                        className="nav-link btn btn-clean"
                                        data-toggle="tab"
                                        data-target="#Automacao"
                                        role="tab"
                                    >
                                        Automação
                                    </NavLink>
                                </li>
                            </ul>
                            <div className="tab-content">
                                {modoAtendimento === "FILA" && fila ? (
                                    <div className="w-100 d-flex flex-column align-items-center justify-content-center">
                                        <h5 className="m-0">
                                            Modo Atendimento ativado
                                            <OverlayTrigger
                                                overlay={
                                                    <Tooltip id="tooltip-disabled">
                                                        Com o modo atendimento
                                                        ativado, você só pode
                                                        acessar a página de
                                                        atendimento de cobrança.
                                                        Assim que você acabar um
                                                        atendimento, você será
                                                        automaticamente
                                                        direcionado para o
                                                        próximo.
                                                    </Tooltip>
                                                }
                                                placement="bottom"
                                            >
                                                <FontAwesomeIcon
                                                    className="ml-3"
                                                    icon={faInfoCircle}
                                                />
                                            </OverlayTrigger>
                                        </h5>
                                        <span>Fila: {fila.DS_GRUPO}</span>
                                        {indicadoresFila && (
                                            <span>
                                                {
                                                    indicadoresFila.NR_ATENDIMENTOS
                                                }{" "}
                                                Clientes nessa Fila - Total de{" "}
                                                {formatMoneyReais(
                                                    indicadoresFila.VL_ATENDIMENTOS
                                                )}
                                            </span>
                                        )}
                                    </div>
                                ) : modoAtendimento === "HELP DESK" ? (
                                    <div className="w-100 d-flex flex-column align-items-center justify-content-center">
                                        <h5 className="m-0">
                                            Modo Atendimento ativado
                                            <OverlayTrigger
                                                overlay={
                                                    <Tooltip id="tooltip-disabled">
                                                        Com o modo atendimento
                                                        ativado, você só pode
                                                        acessar a página de
                                                        atendimento de Whatsapp.
                                                        Enquanto você estiver
                                                        nesse modo, você estará
                                                        apto a receber novos
                                                        atendimentos.
                                                    </Tooltip>
                                                }
                                                placement="bottom"
                                            >
                                                <FontAwesomeIcon
                                                    className="ml-3"
                                                    icon={faInfoCircle}
                                                />
                                            </OverlayTrigger>
                                        </h5>
                                        <span>
                                            Equipe de Atendimento:{" "}
                                            {
                                                HELP_DESK.equipe
                                                    .DS_EQUIPE_HELP_DESK
                                            }
                                        </span>
                                    </div>
                                ) : (
                                    <Switch>
                                        <PrivatedRoute
                                            path={ACESSOS.GERAL.DS_BASE_URL}
                                            component={GeralTab}
                                            isPrivate
                                        />
                                        <PrivatedRoute
                                            path={
                                                ACESSOS.ATENDIMENTO.DS_BASE_URL
                                            }
                                            component={AtendimentoTab}
                                            isPrivate
                                            idModulo={
                                                ACESSOS.ATENDIMENTO.ID_MODULO
                                            }
                                        />
                                        <PrivatedRoute
                                            path={ACESSOS.COBRANCA.DS_BASE_URL}
                                            component={CobrancaTab}
                                            isPrivate
                                            idModulo={
                                                ACESSOS.COBRANCA.ID_MODULO
                                            }
                                        />
                                        <PrivatedRoute
                                            path={"/AssistenciaTecnica"}
                                            component={AssistenciaTecnicaTab}
                                            isPrivate
                                            idModulo={
                                                ACESSOS.ASSISTENCIA.ID_MODULO
                                            }
                                        />
                                        <PrivatedRoute
                                            path={ACESSOS.VENDAS.DS_BASE_URL}
                                            component={VendasTab}
                                            isPrivate
                                            idModulo={ACESSOS.VENDAS.ID_MODULO}
                                        />
                                        <PrivatedRoute
                                            path={ACESSOS.REPASSE.DS_BASE_URL}
                                            component={RepasseTab}
                                            isPrivate
                                            idModulo={ACESSOS.REPASSE.ID_MODULO}
                                        />
                                        <PrivatedRoute
                                            path={
                                                ACESSOS.ENTREGA_DE_CHAVES
                                                    .DS_BASE_URL
                                            }
                                            component={VistoriaEntregaChaveTab}
                                            isPrivate
                                            idModulo={
                                                ACESSOS.ENTREGA_DE_CHAVES
                                                    .ID_MODULO
                                            }
                                        />
                                        <PrivatedRoute
                                            path={"/PortalAdmin"}
                                            component={CobrancaTab}
                                            isPrivate
                                            idModulo={7}
                                        />
                                        <PrivatedRoute
                                            path={ACESSOS.HELPDESK.DS_BASE_URL}
                                            component={HelpDeskTab}
                                            isPrivate
                                            idModulo={
                                                ACESSOS.HELPDESK.ID_MODULO
                                            }
                                        />
                                        <PrivatedRoute
                                            path={ACESSOS.AUTOMACAO.DS_BASE_URL}
                                            component={AutomacaoTab}
                                            isPrivate
                                            idModulo={
                                                ACESSOS.AUTOMACAO.ID_MODULO
                                            }
                                        />
                                    </Switch>
                                )}
                            </div>
                        </div>
                    </ClickAwayListener>
                </div>
            </div>
        </div>
    );
}
